import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, unref as _unref, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "input-element__label"
}

import BasicButton from '@/components/UI/BasicButton.vue';
import LoadingIndicator from '@/components/UI/LoadingIndicator.vue';
import { computed } from 'vue';
import { Form, Field, ErrorMessage, configure } from 'vee-validate';
import FormField from '@/types/formField';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicForm',
  props: {
    schema: {},
    validationSchema: {},
    btnTitle: {}
  },
  emits: ["submitHandler"],
  setup(__props: any, { emit }) {

const props = __props;



configure({
  validateOnInput: true,
});



const store = useStore();
const isLoading = computed((): boolean => store.state.authModule.isLoading);

const onSubmit = (values: object) => {
  emit('submitHandler', values);
}

const onInput = (e) => {
  const target = e.target as HTMLInputElement;
  const parent = target.closest('.input-element') as HTMLElement;
  target.value ? parent?.classList.add('not-empty') : parent?.classList.remove('not-empty')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Form), {
    class: "form",
    "validation-schema": props.validationSchema,
    onSubmit: onSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (isLoading.value)
            ? (_openBlock(), _createBlock(LoadingIndicator, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.schema, ({ name, label, children, as, id, ...attrs }) => {
        return (_openBlock(), _createElementBlock("div", {
          key: name,
          class: "input-element"
        }, [
          _createElementVNode("label", { for: name }, [
            _createVNode(_unref(Field), _mergeProps({
              id: name,
              as: as,
              name: name
            }, attrs, { onInput: onInput }), {
              default: _withCtx(() => [
                (children && children.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(children, ({ tag, text, ...childAttrs }, idx) => {
                      return (_openBlock(), _createBlock(_resolveDynamicComponent(tag), _mergeProps({ key: idx }, childAttrs), {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(text), 1)
                        ]),
                        _: 2
                      }, 1040))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1040, ["id", "as", "name"]),
            label
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(label), 1))
              : _createCommentVNode("", true),
            _createVNode(_unref(ErrorMessage), {
              id: `${id}-error`,
              class: "error",
              name: name,
              "aria-live": "assertive",
              role: "alert"
            }, null, 8, ["id", "name"])
          ], 8, _hoisted_1)
        ]))
      }), 128)),
      _createVNode(BasicButton, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.btnTitle), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}
}

})